<template>
	<div>
		<div class="col-xs-12 col-lg-12 pagination pagination-top">
			<div class="row">
				<div  class="col-xs-12 col-lg-6 pagination-total">
					Selecionado {{ selected_total }} de {{ total }} {{ label }}.
				</div>
				<div class="col-xs-12 col-lg-6 weight-capacity-total">
					<button class="btn-view-map" @click="$parent.show_modal_map = true">
						<i class="fa fa-map-marker-alt"></i> VISUALIZAR NO MAPA
					</button>
					<div class="weight-capacity">
						<span class="weight-capacity-left"><i class="fas fa-fw fa-truck-loading"></i> Capacidade </span>
						<span class="weight-capacity-right">{{ getWeightCapacity(selected_weight_capacity) }}</span>
					</div>
					<div v-if="label == 'entregas'" class="weight-capacity">
						<span class="weight-capacity-left"><i class="fas fa-fw fa-weight-hanging"></i> Peso </span>
						<span class="weight-capacity-right">{{ getWeight(selected_weight) }}</span>
					</div>
				</div>
			</div>
		</div>
		<div class="col-xs-12 col-lg-12" style="padding: 0px;">
			<div class="table-wrapper">
				<DataTable 
					:value="list"
					:selection.sync="selectedList"
					:reorderableColumns="true"
					autoLayout
					stripedRows
					removableSort
					dataKey="id"
					sortMode="multiple"
					tableStyle="width: 100%"
					@update:selection="on_select"
					@sort="onSort"
					@row-select="onRowSelect"
					@row-unselect="onRowUnselect"
					@row-select-all="onSelectAll"
					@row-unselect-all="onUnselectAll"
				>
					<template #empty>
						<div style="text-align: center;">
							<span>NENHUM REGISTRO</span>
						</div>
					</template>
					<template #loading>
						<div style="text-align: center;">
							<span>CARREGANDO INFORMAÇÕES...</span>
						</div>
					</template>
					<Column selectionMode="multiple"></Column>
					<Column v-for="col of selectedColumns" :key="col.field" :field="col.field" :header="col.header" :sortable="col.field != 'street'">
						<template #body="{ data }">
							<div v-html="item_modified(data[col.field], col.field, data)"></div>
						</template>
					</Column>
				</DataTable>
				<Paginator :rows="per_page" :totalRecords="total" @page="onPage($event)">
					<template #start>
						Mostrando {{ start }}-{{ end }} de {{ total }} resultados.
					</template>
				</Paginator>
			</div>
		</div>
		<div class="col-xs-12 col-lg-12 pagination pagination-bottom">
			<div class="row">
				<div class="col-xs-12 col-lg-6 pagination-total">
					Selecionado {{ selected_total }} de {{ total }} {{ label }}.
				</div>
				<div class="col-xs-12 col-lg-6 weight-capacity-total">
					<div class="weight-capacity">
						<span class="weight-capacity-left"><i class="fas fa-fw fa-truck-loading"></i> Capacidade </span>
						<span class="weight-capacity-right">{{ getWeightCapacity(selected_weight_capacity) }}</span>
					</div>
					<div v-if="label == 'entregas'" class="weight-capacity">
						<span class="weight-capacity-left"><i class="fas fa-fw fa-weight-hanging"></i> Peso </span>
						<span class="weight-capacity-right">{{ getWeight(selected_weight) }}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Paginator from 'primevue/paginator';
//import ColumnGroup from 'primevue/columngroup';
//import Row from 'primevue/row';

	export default {
		name: "RoutingPaginatedDataTable",

		components: {
			DataTable,
			Column,
			Paginator
		},

		props: {
			headers: {
				type: Object,
				require: true,
			},
			ordering: {
				type: Array,
				require: false,
			},
			order: {
				type: String,
				require: false,
			},
			list: {
				type: Array,
				require: true,
			},
			page: {
				type: Number,
				require: false,
				default: 0,
			},
			per_page: {
				type: Number,
				require: false,
				default: 0,
			},
			total: {
				type: Number,
				require: false,
				default: 0,
			},
			label: {
				type: String,
				require: false,
				default: "",
			},
			modifiers: {
				type: Object,
				require: false,
				default: () => {},
			},
			select_all_return_origin: {
				type: Function,
				require: false,
				default: undefined,
			},
			on_select: {
				type: Function,
				require: false,
				default: undefined,
			},
			on_select_return_origin: {
				type: Function,
				require: false,
				default: undefined,
			},
			selected: {
				type: Array,
				require: false,
				default: undefined,
			},
			selected_return_origin: {
				type: Array,
				require: false,
				default: undefined,
			},
			unselected_return_origin: {
				type: Array,
				require: false,
				default: undefined,
			},
			is_selected: {
				type: Boolean,
				require: false,
				default: false,
			},
			selected_total: {
				type: Number,
				require: true,
				default: 0,
			},
			selected_weight_capacity: {
				type: Number,
				require: true,
				default: 0.0,
			},
			selected_weight: {
				type: Number,
				require: false,
				default: 0.0,
			},
			columns: {
				type: Array,
				require: true,
			},
			selectedColumns: {
				type: Array,
				require: true,
			}
		},

		data: function() {
			return {
				selectedList: this.selected,
			};
		},
		
		computed: {
			order_field: function() {
				if (this.order) return this.order.split("-").shift();
				if (this.ordering && this.ordering.length > 0) return this.ordering[0];
				return false;
			},

			order_direction: function() {
				if (this.order) {
					const split = this.order.split("-");
					if (split.length > 1) return split[1];
				}
				return "DESC";
			},

			start: function() {
				if (this.list.length == 0) return 0;
				return (this.page * this.per_page) + 1;
			},

			end: function() {
				if (this.per_page == 0) {
					return this.total;
				}

				if (this.list.length < this.per_page) {
					return (this.page * this.per_page) + this.list.length;
				} else {
					return (this.page + 1) * this.per_page;
				}
			},
		},

		watch: {
			selected: {
				immediate: true,
				handler(newSelection) {
					this.selectedList = newSelection || [];
				}
			}
		},

		methods: {
			item_modified: function(value, index, item) {
				if ((this.modifiers !== undefined) && (this.modifiers[index] != undefined)) {
					return this.modifiers[index](value, item);
				}
				return value;
			},

			onSort: function(event) {
				if (typeof event.multiSortMeta[0] !== "undefined") {
					let new_order = {
						field: "",
						order: "",
					};

					new_order.field = event.multiSortMeta[0].field;
					new_order.order = event.multiSortMeta[0].order == 1 ? "ASC" : "DESC";
					this.reorder(new_order.field + "-" + new_order.order);
				} else {
					this.reorder("");
				}
			},

			reorder: function(new_order) {
				this.$emit("onReorder", new_order);
			},

			onRowSelect: function(event) {
				this.$emit("onSelect", event.data);
			},
			
			onRowUnselect: function(event) {
				this.$emit("onUnselect", event.data);
			},

			onSelectAll: function(event) {
				this.$emit("onSelectAll", event.data);
			},
			
			onUnselectAll: function() {
				this.$emit("onUnselectAll", this.selectedList);
			},
			
			onPage: function(event) {
				this.$emit("onPage", event);
			},

			verifySelectedAll: function(list, selected, is_object) {
				if (list.length > 0) 
				{
					let response = true;
					list.map(r => {
						if (is_object) {
							let index = selected.findIndex(element => element.id == r.id);
							if (index == -1) {
								response = false;
							}
						} else {
							if (!selected.includes(r.id)) {
								response = false;
							}
						}
					});
					return response;
				} else {
					return false;
				}
			},

			countSelected: function() {
				let count = 0;
				this.list.map(r => {
					if (this.selectedList.findIndex(element => element.id == r.id) != -1) count++;
				});
				return count;
			},

			getWeight: function(weight) {
				let weight_formatted = "";

				if (weight < 1000) weight_formatted = weight.toFixed(2) + " kg";
				else weight_formatted = (weight / 1000).toFixed(2) + " t";

				return weight_formatted.replace(".", ",");
			},

			getWeightCapacity: function(weight) {
				let weight_formatted = "";

				if (weight < 1000) weight_formatted = weight.toFixed(2) + " kg";
				else weight_formatted = (weight / 1000).toFixed(2) + " t";

				return weight_formatted.replace(".", ",");
			},
		},
	}
</script>

<style scoped>
@import url("../../../node_modules/primevue/resources/primevue.css");
@import url("../../../node_modules/primevue/resources/themes/saga-blue/theme.css");
@import url("../../../node_modules/primeicons/primeicons.css");
.table-wrapper {
	width: 100%;
}

.table {
	width: 100%;
	background: #fff;
	border-spacing: 0px;
	border-collapse: collapse;
}

.table th, .table td {
	text-align: left;
	padding: 10px;
	border-top: 1px solid #f0f0f0;
	font-size: 14px;
}

table > tbody > tr:hover {
	background-color: #f0f0f0;
}

.order {
	background: none;
	border: none;
	color: #aaa;
}
.order.active {
	color: #222;
}


.pointered {
    cursor: pointer;
}

.pagination {
	font-size: 14px;
    padding: 10px 15px;
}

.pagination-top {
	border-bottom: 1px solid #f0f0f0;
}

.pagination-bottom {
	border-top: 1px solid #f0f0f0;
}


.pagination-button {
	float: right;
	background: none;
	border: none;
	width: 30px;
	height: 30px;
	font-size: 20px;
	padding: 0;
	text-align: center;
	color: #999;
}
.pagination-button:disabled {
	color: #ddd;
}


.pagination-total {
	height: 40px;
	line-height: 45px;
}

.btn-view-map {
	display: inline;
	font-size: 12px;
	margin-left: 15px;
	border: 1px solid #ccc;
	background-color: #eee;
	padding: 5px 10px;
}

.weight-capacity-total {
	height: 40px;
	line-height: 45px;
	text-align: right;
}

.weight-capacity {
	display: inline;
	font-size: 12px;
	margin-left: 15px;
}

.weight-capacity-left {
	text-align: left;
	border: 1px solid #ccc;
	/*border-top-left-radius: 3px;
	border-bottom-left-radius: 3px;*/
	background-color: #eee;
	padding: 5px 10px;
}

.weight-capacity-right {
	text-align: right;
	border: 1px solid #ccc;
	/*border-top-right-radius: 3px;
	border-bottom-right-radius: 3px;*/
	background-color: #ccc;
	padding: 5px 10px;
	font-weight: 600;
}

.text-center {
	text-align: center;
}
</style>

<style>
.p-datatable .p-sortable-column .p-column-title, 
.p-datatable .p-sortable-column .p-sortable-column-icon, 
.p-datatable .p-sortable-column .p-sortable-column-badge,
.p-column-header-content .p-column-title {
	font-size: 14px;
}

.p-datatable .p-datatable-thead > tr > th,
.p-datatable .p-datatable-tbody > tr > td {
	padding: 10px;
	font-size: 14px;
}

.p-checkbox .p-checkbox-box {
	width: 14px;
    height: 14px;
	border: 1px solid #2c3e50;
    border-radius: 2px;
}

.p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box:hover {
    border-color: #2c3e50;
}

.p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box.p-highlight:hover {
    border-color: #2c3e50;
    background: #2c3e50;
    color: #ffffff;
}

.p-datatable .p-datatable-tbody > tr.p-highlight,
.p-datatable.p-datatable-striped .p-datatable-tbody > tr:nth-child(even).p-highlight {
    background: #ffffff;
    color: #495057;
}

.p-checkbox .p-checkbox-box.p-highlight {
    border-color: #2c3e50;
    background: #2c3e50;
}	

.p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box.p-focus {
    box-shadow: none;
    border-color: #2c3e50;
}

.p-checkbox .p-checkbox-box .p-checkbox-icon {
    transition-duration: 0.2s;
    color: #ffffff;
    font-size: 9px;
    font-weight: 600;
}

.p-datatable.p-datatable-gridlines .p-datatable-tbody > tr > td {
    font-size: 12px;
    padding: 5px;
}

.p-datatable.p-datatable-gridlines .p-datatable-tbody > tr > td.p-selection-column {
    padding: 5px 1rem;
}

.p-checkbox {
	justify-content: center;
    align-items: center;
}

.p-paginator {
	font-size: 14px;
	color: #2c3e50;
}

.p-paginator .p-paginator-pages .p-paginator-page.p-highlight {
  background: #222;
  border-color: #222;
  color: #fff;
  border-radius: 0px;
}
</style>